module.exports = __webpack_public_path__ + "img/DefaultImage.e1f0dead.png";